//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {jFunc} from "../../../../../../js/jfunctions.min";
import vSelectric from "../../../../../../vue.js/v-selectric/v-selectric.vue";

export default {
  components : {
    'v-selectric' : vSelectric,
  },
  data : function() {
    return {
      ITEMS : {},
      REGIONS : [],
      selectedRegion : false,
      dealersListPageNumber : 1,
      dealersOnPage : 5,
      pageLoadingTimeout : 1000,
      dealersLoading : false,
      //showMore: false,
      showMore: true,
    }
  },
  methods : {
    getMapElementColor(elementCode) {
      let self = this;
      let color = '#F5F5F5';

      if(elementCode.indexOf('_TEXT') > -1) {
        if(elementCode == self.selectedRegion + '_TEXT') {
          color = '#FFF';
        }
        else {
          color = '#A5A5A5';
        }
      }
      else {
        if(elementCode == self.selectedRegion) {
          color = '#CA3737';
        }
      }

      return color;
    },
    selectRegion(regionCode) {
      let self = this;
      //self.showMore = false;
      self.showMore = true;
      self.$set(self.$data, 'selectedRegion', regionCode);
    },
    toggleDropdown() {
      let self = this;
      self.$set(self.$data, 'showMore', !self.showMore);
    },
    showNextDealersPage() {
      let self = this;

      if(self.dealersLoading)
        return;

      if(Object.keys(self.getDealersPage(self.dealersListPageNumber + 1)).length) {
        $('.dealers-list .loading-block').show();
        self.dealersLoading = true;
        setTimeout(function() {
          self.dealersLoading = false;
          self.dealersListPageNumber++;
          $('.dealers-list .loading-block').hide();
          self.showNextDealersPage();
        }, self.pageLoadingTimeout);
      }
      else {
        $('.dealers-list .loading-block').hide();
      }
    },
    /**
     * disabled
     * @param pageNumber
     * @returns {*|*[]}
     */
    getDealersPage(pageNumber) {
      let self = this;
      let result = [];

      if(!pageNumber)
        pageNumber = self.dealersListPageNumber;

      let startIndex = (pageNumber * self.dealersOnPage) - self.dealersOnPage;
      let endIndex = startIndex + self.dealersOnPage;
      let resultsCounter = 0;

      for( let i in jFunc.sortArrayOfObjectsByKeyValue(self.ITEMS, 'SORT')) {
        let currentItem = self.ITEMS[i];
        if(jFunc.getNested(currentItem, 'PROPERTIES', 'NATIONAL_REGION', 'VALUE_XML_ID') == self.selectedRegion) {
          resultsCounter++;
          if(resultsCounter > startIndex && resultsCounter <= endIndex) {
            result.push(currentItem);
          }
        }
      }

      return result.length ? jFunc.sortArrayOfObjectsByKeyValue(result, 'SORT') : [];
    },
    refreshScrollBar() {
      console.log('refresh');
      let Scrollbar = window.Scrollbar;
      if(!!Scrollbar) {

        // Scrollbar.use(window.OverscrollPlugin);
        Scrollbar.init(document.querySelector('.dealers-items'), {
          plugins : {
            overscroll : {
              effect : 'glow',
              damping : 0.2,
              maxOverscroll : 150,
              glowColor : '#CA3737'
            }
          }
        });
      }
    },
  },
  watch : {
    selectedRegion() {
      let self = this;
      //self.showMore = false;
      self.showMore = true;
      // self.refreshScrollBar();
    },
  },
  computed : {
    filteredDealers() {
      let self = this;
      let result = [];

      for( let i in self.ITEMS) {
        let currentItem = self.ITEMS[i];
        if(jFunc.getNested(currentItem, 'PROPERTIES', 'NATIONAL_REGION', 'VALUE_XML_ID') == self.selectedRegion) {
          result.push(currentItem);
        }
      }

      if (result.length <= 4)
        self.showMore = true;

      return result;
    },
    dealersNumeralString() {
      let self = this;
      return jFunc.getNumeral(self.filteredDealers.length, ['дилер', 'дилера', 'дилеров']);
    },
  },
  mounted() {
      let self = this;
      self.$set(self.$data, 'selectedRegion', jFunc.getFirstItem(self.REGIONS).ID);

    $(function () {
      // self.refreshScrollBar();

      // $(window).on('scroll', function() {
      //   if(window.scrollY + window.innerHeight > document.querySelector('.dealers-list .loading-block').offsetTop) {
      //     self.showNextDealersPage();
      //   }
      // });

      $('body').on('click', '.dealers-item-phone-wrapper a', function (e) {
        e.stopPropagation();
      });

      $('body').on('click', '.dealers-item-phone-wrapper', function (e) {
        let self = $(this).find('a');
        if(!self.hasClass('active')) {
          e.preventDefault();
          $(this).addClass('active');
          let selfText = self.text().split('');
          self.text('');
          selfText.forEach(function (el, i) {
            setTimeout(function () {
              self.append(el);
            }, i * 25);
          });
        }

        ym(86548431,'reachGoal','showphone');
        gtag('event', 'Показать телефон', {'event_category' : 'button', 'event_action' : 'click', 'event_label' : ' showphone '});

      });
    });
  }
}



// WEBPACK FOOTER //
// ./www/local/templates/epotos/components/bitrix/news.list/dealers/template.vue